import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ApiVisa,
  Pagination, PrintableFormatContainerModel, PrintableFormatService
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../shared-utilities/visa';

@Component({
  selector: 'ng-select-printable-format',
  templateUrl: './select-printable-format-drop-down.component.html',
  styleUrls: ['./select-printable-format-drop-down.component.scss']
})

export class SelectPrintableFormatDropDownComponent implements OnInit, OnDestroy {

  apiVisa = AppConfig.apiVisa;
  @Input() printableFormat: FormControl;
  @Input() txn_type: string;

  @Output() printableFormatChange = new EventEmitter<FormControl>();
  @Output() selectedPrintableFormat = new EventEmitter<PrintableFormatContainerModel>();

  private subs = new SubSink();

  pagination = new Pagination();
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<PrintableFormatContainerModel[]> = new ReplaySubject<PrintableFormatContainerModel[]>(1);
  printableFormatList: PrintableFormatContainerModel[];

  constructor(private printableFormatService: PrintableFormatService) { }

  ngOnInit() {
    this.pagination.conditionalCriteria = [
      { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
      { columnName: 'txn_type', operator: '=', value: this.txn_type },
    ];
    this.subs.sink = this.printableFormatService.getByCriteria(this.pagination, this.apiVisa).subscribe(
      {
        next: resolve => {
          this.printableFormatList = resolve.data;
          this.filteredOptions$.next(this.printableFormatList);
        }
      });
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({ next: resolve => this.filterPrintable(resolve) });
  }

  filterPrintable(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.printableFormatList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.printableFormatList.filter(c => c.bl_prt_printable_format_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const pf = this.printableFormatList.find(i => i.bl_prt_printable_format_hdr.guid === e)
    this.selectedPrintableFormat.emit(pf);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
